import { Box, Container, Typography } from "@material-ui/core";
import { useState } from "react";
import { useRouteMatch } from "react-router-dom";
import { Header } from "../../../shared/components/header";
import { supportEmail } from "../../../shared/consts/emails";
import { useInIframe } from "../../../shared/hooks";
import { useHelpCenter } from "../../../shared/hooks/useHelpCenter";
import { CloseIcon } from "../../../shared/icons/CloseIcon";
import { HelpIcon } from "../../../shared/icons/HelpIcon";
import { PrivacyIcon } from "../../../shared/icons/PrivacyIcon";
import { SecurityIcon } from "../../../shared/icons/SecurityIcon";
import { TermsIcon } from "../../../shared/icons/TermsIcon";
import { useStyles } from "./helpCenter.styles";

type Policies = {
  terms: boolean;
  privacy: boolean;
  security: boolean;
};

export const HelpCenter = ({ navigation }) => {
  const classes = useStyles();
  const isInIframe = useInIframe();
  const { useQuery } = useHelpCenter();
  const { data: policyData } = useQuery();
  const [showPolicy, setShowPolicy] = useState<Policies>({
    terms: false,
    privacy: false,
    security: false,
  });
  const { url } = useRouteMatch();
  const isWithoutLogin = url && url === "/help";

  const containerClass = isWithoutLogin
    ? `${classes.container} ${classes.extraPadding}`
    : classes.container;

  const closeModal = () => {
    setShowPolicy({
      terms: false,
      privacy: false,
      security: false,
    });
  };

  const termsData = policyData
    ? policyData.policies.find(
        (data) => data.policyType === "Terms & conditions"
      )
    : null;
  const privacyData = policyData
    ? policyData.policies.find((data) => data.policyType === "Privacy")
    : null;
  const securityData = policyData
    ? policyData.policies.find((data) => data.policyType === "Security")
    : null;

  return (
    <Header navigation={navigation}>
      <>
        {!showPolicy.terms && !showPolicy.privacy && !showPolicy.security ? (
          <Container className={containerClass}>
            {!isInIframe && (
              <Typography
                component="h5"
                variant="h5"
                align="left"
                className={classes.title}
              >
                Fruition Help Center
              </Typography>
            )}
            <Container className={classes.contentContainer}>
              <a href={supportEmail} className={classes.emailLink}>
                <Container className={classes.needHelpContainer}>
                  <HelpIcon />
                  <Box className={classes.needHelpContentContainer}>
                    <Typography
                      variant="h6"
                      align="left"
                      className={classes.sectionTitle}
                    >
                      Need Help
                    </Typography>
                    <Typography
                      variant="body2"
                      align="left"
                      className={classes.sectionSubTitle}
                    >
                      Contact Us
                    </Typography>
                  </Box>
                </Container>
              </a>
            </Container>
            <Container className={classes.contentContainer}>
              <Box>
                <Box
                  className={classes.termsContainer}
                  onClick={() =>
                    setShowPolicy({
                      terms: true,
                      privacy: false,
                      security: false,
                    })
                  }
                >
                  <TermsIcon />
                  <Typography
                    variant="h6"
                    align="left"
                    className={classes.sectionTitle}
                  >
                    Terms of Service
                  </Typography>
                </Box>
                <Box
                  className={classes.termsContainer}
                  onClick={() =>
                    setShowPolicy({
                      terms: false,
                      privacy: true,
                      security: false,
                    })
                  }
                >
                  <PrivacyIcon />
                  <Typography
                    variant="h6"
                    align="left"
                    className={classes.sectionTitle}
                  >
                    Privacy
                  </Typography>
                </Box>
                <Box
                  className={classes.termsContainer}
                  onClick={() =>
                    setShowPolicy({
                      terms: false,
                      privacy: false,
                      security: true,
                    })
                  }
                >
                  <SecurityIcon />
                  <Typography
                    variant="h6"
                    align="left"
                    className={classes.sectionTitle}
                  >
                    Security
                  </Typography>
                </Box>
              </Box>
            </Container>
          </Container>
        ) : showPolicy.privacy && privacyData ? (
          <Container className={containerClass}>
            <Box className={classes.policyHeaderContainer}>
              <Typography
                component="h5"
                variant="h5"
                align="left"
                className={classes.title}
              >
                Fruition Privacy
              </Typography>
              <Box className={classes.closeButton} onClick={closeModal}>
                <CloseIcon />
              </Box>
            </Box>
            <div dangerouslySetInnerHTML={{ __html: privacyData.body }}></div>
          </Container>
        ) : showPolicy.security && securityData ? (
          <Container className={containerClass}>
            <Box className={classes.policyHeaderContainer}>
              <Typography
                component="h5"
                variant="h5"
                align="left"
                className={classes.title}
              >
                Fruition Security
              </Typography>
              <Box className={classes.closeButton} onClick={closeModal}>
                <CloseIcon />
              </Box>
            </Box>
            <div dangerouslySetInnerHTML={{ __html: securityData.body }}></div>
          </Container>
        ) : showPolicy.terms && termsData ? (
          <Container className={containerClass}>
            <Box className={classes.policyHeaderContainer}>
              <Typography
                component="h5"
                variant="h5"
                align="left"
                className={classes.title}
              >
                Fruition Terms of Service
              </Typography>
              <Box className={classes.closeButton} onClick={closeModal}>
                <CloseIcon />
              </Box>
            </Box>
            <div dangerouslySetInnerHTML={{ __html: termsData.body }}></div>
          </Container>
        ) : null}
      </>
    </Header>
  );
};
